import React, { useState, createRef, useEffect } from "react";
import "./Widget.scss";
import { useDispatch, useSelector } from "react-redux";
import { FiCalendar } from "react-icons/fi";
import { CgClose } from "react-icons/cg";
import LogoGrey from "../../assets/LogoGrey.png";
//containers
import FirstWidgetScreen from "../views/FirstWidgetScreen/FirstWidgetScreen";
import ChooseLocation from "../views/ChooseLocation/ChooseLocation";
import BookingStep1 from "../views/BookingStep1/BookingStep1";
import BookingStep2 from "../views/BookingStep2/BookingStep2";
import ChooseSlot from "../views/ChooseSlot/ChooseSlot";
import BookingForm from "../views/BookingForm/BookingForm";
import AllReviews from "../views/AllReviews/AllReviews";
//components
import BookingHeader from "../../components/BookingHeader/BookingHeader";
import {
  getWidgetInfo,
  getFreeSlots,
  createAppointment,
  getPlace,
} from "../../store/actions/widget";
import { locale } from "../../translate/sweden";

const Widget = (props) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [widgetOpened, setWidgetOpened] = useState(-1);
  const [termsOpen, setTermsOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [reviewsOpen, setReviewsOpen] = useState(false);
  const [service, setService] = useState({
    service: null,
    duration: null,
    price: null,
    service_id: null,
  });
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const [errors, setErros] = useState({
    first_name: false,
    last_name: false,
    email: false,
    phone: false,
  });
  const [bookingNotes, setBookingNotes] = useState(null);
  const [worker, setWorker] = useState({
    workerName: "",
    calendar_id: null,
    toc: null,
  });
  const [time, setTime] = useState({ date: null, time: null });
  const bookingRef = createRef(null);
  const steps = useSelector((state) => state.widget.steps);

  const widgetInfo = useSelector((state) => state.widget.widget);
  const place = useSelector((state) => state.widget.place);

  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    dispatch(getWidgetInfo(query.get("client")));
    // eslint-disable-next-line
  }, []);

  const handleScroll = () => {
    const scrollTop = bookingRef.current.scrollTop;
    if (scrollTop > 15) {
      document.querySelector(".BookingHeader").className =
        "BookingHeader scroll";
      !document
        .querySelector(".widgetWrapper")
        .classList.contains("scrolled") &&
        document.querySelector(".widgetWrapper").classList.add("scrolled");
    } else {
      document.querySelector(".BookingHeader").className = "BookingHeader";
      document.querySelector(".widgetWrapper").classList.remove("scrolled");
    }
  };
  const handleNavBack = () => {
    if (termsOpen) {
      setTermsOpen(false);
    } else if (notesOpen) {
      setNotesOpen(false);
      // setBookingNotes(null);
    } else if (reviewsOpen) {
      setReviewsOpen(false);
    } else {
      if (steps !== 5 && step === 2) {
        setStep(0);
      } else {
        setStep((p) => (p = p - 1));
      }
      document.querySelector(".BookingHeader").className = "BookingHeader";
      document.querySelector(".widgetWrapper").classList.remove("scrolled");
    }
  };

  const handleBookingNotesChange = (val) => {
    setBookingNotes(val);
  };
  const chooseService = (ser, dur, price, ser_id) => {
    setService({
      service: ser,
      duration: dur,
      price: price,
      service_id: ser_id,
    });
  };

  const handleFirstNameChange = (val) => {
    setUser((u) => ({ ...u, first_name: val }));
  };
  const handleLastNameChange = (val) => {
    setUser((u) => ({ ...u, last_name: val }));
  };
  const handleEmailChange = (val) => {
    setUser((u) => ({ ...u, email: val }));
  };
  const handlePhoneChange = (val) => {
    setUser((u) => ({ ...u, phone: val }));
  };
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const createAppointmentHandler = () => {
    if (
      user.first_name !== "" &&
      user.last_name !== "" &&
      validateEmail(user.email) &&
      user.phone !== ""
    ) {
      const handleClose = () => {
        setWidgetOpened(0);
        setStep(0);
        setUser({ first_name: "", last_name: "", email: "", phone: "" });
        setErros({
          first_name: false,
          last_name: false,
          email: false,
          phone: false,
        });
        setBookingNotes(null);
      };
      dispatch(
        createAppointment(
          time.date,
          time.time.slice(0, -3),
          service.service_id,
          worker ? worker.calendar.calendar_id : null,
          bookingNotes,
          user,
          handleClose
        )
      );
    } else {
      user.first_name === ""
        ? setErros((e) => ({ ...e, first_name: true }))
        : setErros((e) => ({ ...e, first_name: false }));
      user.last_name === ""
        ? setErros((e) => ({ ...e, last_name: true }))
        : setErros((e) => ({ ...e, last_name: false }));
      user.phone === ""
        ? setErros((e) => ({ ...e, phone: true }))
        : setErros((e) => ({ ...e, phone: false }));
      !validateEmail(user.email)
        ? setErros((e) => ({ ...e, email: true }))
        : setErros((e) => ({ ...e, email: false }));
      bookingRef.current.scrollTo(0, 0);
    }
  };

  return (
    <>
      {widgetInfo ? (
        <div className="Widget">
          <div
            className={
              "widgetWrapper" +
              (widgetOpened === 1 ? " active" : "") +
              (widgetOpened === 0 ? " not-active" : "")
            }
          >
            {/* HEADER */}
            {step > 0 && (
              <BookingHeader
                step={step}
                onClose={() => setWidgetOpened(0)}
                termsOpen={termsOpen}
                notesOpen={notesOpen}
                onBack={handleNavBack}
                steps={steps}
              />
            )}
            {/* WIDGET SCREENS */}
            {step === 0 && !reviewsOpen && (
              <FirstWidgetScreen
                widgetInfo={widgetInfo}
                nextStep={() => (steps === 5 ? setStep(1) : setStep(2))}
                widgetOpened={widgetOpened}
                setWidgetOpened={setWidgetOpened}
                openReviews={() => setReviewsOpen(true)}
                onClose={() => setWidgetOpened(0)}
              />
            )}
            {step === 1 && (
              <ChooseLocation
                nextStep={(id) => {
                  dispatch(getPlace(id, setStep(2)));
                }}
                refr={bookingRef}
                handleScroll={handleScroll}
              />
            )}
            {step === 2 && (
              <BookingStep1
                nextStep={() => setStep(3)}
                refr={bookingRef}
                handleScroll={handleScroll}
                chooseService={chooseService}
              />
            )}
            {step === 3 && (
              <BookingStep2
                persons={steps === 4 ? widgetInfo.staff : place.staff}
                nextStep={(worker) => {
                  setStep(4);
                  setWorker(worker);
                  dispatch(
                    getFreeSlots(
                      service.service_id,
                      worker ? worker.calendar.calendar_id : null
                    )
                  );
                }}
                refr={bookingRef}
                handleScroll={handleScroll}
                service_id={service.service_id}
              />
            )}
            {step === 4 && (
              <ChooseSlot
                select={(date, time) => {
                  setStep(5);
                  setTime({ date, time });
                }}
              />
            )}
            {step === 5 && (
              <BookingForm
                user={user}
                staff={worker}
                service={service}
                time={time}
                refr={bookingRef}
                handleScroll={handleScroll}
                setTermsOpen={setTermsOpen}
                termsOpen={termsOpen}
                notesOpen={notesOpen}
                setNotesOpen={setNotesOpen}
                bookingNotes={bookingNotes}
                handleBookingNotesChange={handleBookingNotesChange}
                handleFirstNameChange={handleFirstNameChange}
                handleLastNameChange={handleLastNameChange}
                handleEmailChange={handleEmailChange}
                handlePhoneChange={handlePhoneChange}
                createAppointmentHandler={createAppointmentHandler}
                errors={errors}
              />
            )}
            {reviewsOpen && (
              <AllReviews
                widgetInfo={widgetInfo}
                handleNavBack={handleNavBack}
              />
            )}
            {/* BOTTOM AREA */}
            <a href="https://bookybook.se/" target="_blanko">
              <div className="bottomWidgetArea">
                {locale.poweredBy} <img src={LogoGrey} alt="Logo grey" />
              </div>
            </a>
          </div>
          <div
            className="open-close"
            style={{
              backgroundImage: `${
                widgetInfo.company.widget_settings.background_color
                  ? widgetInfo.company.widget_settings.background_color
                  : "linear-gradient(117.58deg, #1A73E8 0%, #1A56A6 100%)"
              }`,
            }}
            onClick={() =>
              widgetOpened === 1 ? setWidgetOpened(0) : setWidgetOpened(1)
            }
          >
            {widgetOpened === 1 && -1 ? <CgClose /> : <FiCalendar />}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Widget;
